<template>
	<div class="box-s pr">
    <div class="model_header ptrl-20-16 box-s c7 fw-500 fz-13 " :style="{'background': 'url(' + data.bg_img+ ') no-repeat','background-size': '100%'}" v-if="showpage && !loadFlag">
			<!-- <img class="img_st" :src="data.bg_img" alt=""> -->
      <div class="fz-18 l-h-18 w100 text-hide">{{data.name}}</div>
      <div class="mtb-10-15 l-h-13">{{data.start_time}} - {{data.end_time}}</div>
      <div class="l-h-13">已有{{data.ask_number}}人报名</div>
			<div class="po_104" :style="{'padding-bottom': paddingb }">
        <div class="list_every pd-15 box-s c1 mb-16 ">
					<div class="mb-10 fz-15 fw-500 ">考试说明：</div>
					<div class="fz-14 ls_1 ls-h-20 h83 h120 over-auto">{{data.explain}}</div>
				</div>
        
				<van-list
				v-model="loading"
				:finished="finished"
				:finished-text="finishedtext"
				@load="initData"
			>
				<div class="list_every pd-16-18 box-s mb-16" :class="{ 'mb0': index == list.length - 1 }" v-for="(item, index) in list" :key="index">
						<div class="flexs flex-jus">
							<div class="flexs">
								<img class="wh_46 b-radius-50 mr-10" src="../../assets/img/icon/imitate_icon.png" alt="">

								<div class="fw-500 fz-16 c1 w157 text-hide">{{item.name}}</div>
							</div>
							<div class="flexs  whl-74-24 flex-center fw-500 fz-12 b-radius-12 " :class="{ 'bg_ec':  item.tp_m != 0, 'c0': item.tp_m != 0, 'c17': item.tp_m == 0, 'bg_92': item.tp_m == 0 }" @click="getStart(item)"> 
								{{item.tp_m == 0? '开始考试': '答题报告'}}
								<img v-if="item.tp_m == 0" class="wh_4_6 ml-5" src="../../assets/img/icon/green_arrow.png" alt="">
								<img  v-else class="wh_4_6 ml-5" src="../../assets/img/icon/blue_right_arrow.png" alt="">
							</div>
						</div>

						<div class="flexs fw-500 fz-14 c1 pd-16 box-s bg_f9 b-radius-6 mtb-16">
							<div class="flex1">题目数量： {{item.numbers}}题</div>
							<div class="flex1">总分： {{item.score}}分</div>
						</div>

						<div class="flexs fw-400">
							<div class="flex1 pl-14 box-s">
								<div class="mb-14 fz-12 c1">考试时间</div>
								<div class="fz-14 c3 l-h-14">{{item.start_time}}</div>
							</div>
							<div class="flex1 pl-14 box-s">
								<div class="mb-14 fz-12 c1">考试时限</div>
								<div class="fz-14 c3 l-h-14">{{item.minute}}分钟</div>
							</div>
						</div>

						<div class="c0 flexs flex-end pt-14 bt_e9 mt-18" v-if="item.tp_m == 2" @click="getLook(item)">
							<div class="mr-10 fz-12">查看本科排行</div>
							<img class="wh_8_10" src="../../assets/img/icon/blue_k_arrow.png" alt="">
						</div>
					</div>
		  	</van-list>
			</div>

			
      
		</div>

    

		<div class="btn_contain" v-if="showpage&& !loadFlag">
      <div class="blue_btn" :class="{ 'gray_b': !(data.mc_status == 0 ||  data.mc_status == 2 && data.if_ranking == 1)}" @click="getEnter">
        {{ data.mc_status == 0? '报名参加' : (data.mc_status == 2 && data.if_ranking == 1 ? '查看排行':'已报名') }}
      </div>
    </div>
    <noData v-if="!showpage" top="45%" po="fixed"></noData>
		<loading :loadFlag="loadFlag"></loading>
		<noData v-if="show" po="fixed" top="60%"></noData>
	</div>
</template>
<script>
	import noData from "@/components/noData"
	import loading from "@/components/loading"
	import { dryRunMatch, matchSignUp } from '@/api/api'
	import {getShowPadding, diffPadd, clear} from "@/utils/common.js";
	export default {
		components: {
			loading,
			noData
		},
		data() {
			return {
				paddingb: '',
			  list: [],
				data: {},
				loadFlag: false,
				loading: false,
				finished: false,
				finishedtext: '',
				show:false,
				page: 1,
				showpage: true
			};
		},
		created() {
			clear()
      this.initData()
		},
		mounted(){
			this.paddingb = (document.documentElement.clientWidth / 375) * (60 + diffPadd() + (getShowPadding()? 30 : 0)) + 'px'
		},
		methods: {
			async initData(){
				if(this.loadFlag) return
				this.loadFlag = true
				const res = await dryRunMatch()
				this.loadFlag = false
				this.loading = false
				if(res.code == 1000){
          this.data = res.data
					const { data,  total, last_page, current_page } = res.data.list
					
					if(data.length === 0){
						this.finished = true;
						if(last_page == 1){
							this.show = true
						}
					}
					if(total > 1){
						this.finishedtext = '没有更多数据了'
					}
					let list = data
					if (current_page > 1) {
						this.list = [...this.list, ...list];
					} else {
						this.list = list;
					}
					// 如果当前页数 = 总页数，则已经没有数据
					if (parseInt(current_page) === parseInt(last_page)) {
						this.finished = true;
					}

					// 如果总页数大于当前页码，页码+1
					if (last_page > current_page) {
						this.page++;
					}
				}else {
          this.finished = true;
					if(res.code == 1001){
            this.showpage = false
					} else {
            this.$toast(res.msg)
					}
					
					
				}
			},
      
			// 开始考试
			getStart( data ){

				if(data.tp_m != 0){
          this.$router.push({ path: '/midereport', query: { answer_id: data.answer_id } })
				} else {
					if(this.data.mc_status == 0) return this.$toast('请先报名参加此次模考')
          if(data.numbers == 0) return this.$toast('暂无题目，无法做题哦~')
          const nowTime = new Date().getTime()
					const startTime = new Date(data.start_time.replace(/\-/g, '/')).getTime()
					const endTime = new Date(data.end_time.replace(/\-/g, '/')).getTime()
					if(nowTime < startTime) return this.$toast('考试未开始')
					if(nowTime > endTime)return this.$toast('考试已结束')

					this.$router.push({ path:  '/midestartquest', query: { time_limit: data.minute, test_paper_id: data.id } })
				}
				
			},

      // 底部报名按钮 、 查看排行榜按钮
			async getEnter(){
				if(this.list.length == 0) return this.$toast('暂无试卷，无法报名')
        if(this.data.mc_status == 0){
          
					// 报名参加
          const res = await matchSignUp({ mtc_id: this.data.id })
					if( res.code == 1000 ){
						this.$toast.success('报名成功')
            this.data.mc_status = 1
					} else {
						this.$toast(res.msg)
					}

				} else if(this.data.mc_status == 2 && this.data.if_ranking == 1){

					// 查看排行榜
          this.$router.push({ path: '/ranking', query:{ mtc_id: this.data.id, ts_id: 0 } })
				} else {

					// 已报名
					return
				}


        
			},
			getLook(data){
        this.$router.push({ path: '/ranking', query:{ mtc_id: this.data.id,ts_id: data.id  } })
			}

		}
	};
</script>
<style lang="less" scoped>
.img_st {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
  width: 100%;
	height: 100%;
}
.orange_sty {
	background: #FFF4EA;
	color: #FFAB5A;
}

.mb0 {
	margin-bottom: 0 !important;
}

.model_header {
	height: 227px;

}

.po_104 {
	position: absolute;
	top: 104px;
	left: 50%;
	transform: translateX(-50%);
	width: 343px;
}
.h120::-webkit-scrollbar{
	display: none;
}

/deep/.van-list__finished-text {
	padding-top: 10px;
	line-height: 20px !important;
	font-weight: normal;
}
/deep/.van-list__loading {
	display: none;
}

.gray_b {
	background: #999999;
	color: #FFFFFF;
}

.nodasai {
	position: fixed;
	left: 50%;
	top: 40%;
	transform: translate(-50%, -50%);
}
</style>
